export const frequentlyAskedQuestionsMapper = {
    title: "Dúvidas frequentes",
    faqData: [
        {
            question: "Quais etapas estão envolvidas no processo de análise de dados?",
            answer: "Alinhamento de objetivos → coleta/integração → tratamento dos dados → análises e KPIs → dashboards/relatórios → validação e entrega.",
        },
        {
            question: "Como a segurança dos dados é garantida?",
            answer: "Usamos controle de acesso, boas práticas de segurança, criptografia quando aplicável e confidencialidade (NDA) quando necessário.",
        },
        {
            question: "Qual é o tempo médio de entrega de um projeto?",
            answer: "Varia conforme o tipo e a complexidade: dados/dashboards (2–4 semanas), sites (1–3 semanas), automações (1–3 semanas) e software/app (4–12+ semanas).",
        },
        {
            question: "Quais ferramentas vocês utilizam?",
            answer: "Usamos as stacks mais modernas e confiáveis, com ferramentas líderes do mercado — e nos adaptamos facilmente ao ecossistema e às necessidades da sua empresa.",
        },
    ],
};
